import React from 'react';
import Hierarchy from 'components/Hierarchy';

import { OpenConvalidaResponse, Definition, Group, Task } from 'models/response';

interface Props {
  response: OpenConvalidaResponse;
  setSelectedDefinition: (definition: Definition) => void;
  setSelectedTask: (isActive?: boolean, task?: Task) => void;
  setSelectedGroups: (groups: Group[]) => void;
}

const columns: { accessor: string; Header: string }[] = [
  { accessor: 'username', Header: 'User' },
  { accessor: 'name', Header: 'Name' },
];

const searchTypeValues: { value: string; label: string; parent: 'one' | 'two' | 'three' | 'table' }[] = [
  { value: 'definition', label: 'Definition', parent: 'one' },
  { value: 'task', label: 'Task', parent: 'two' },
  { value: 'group', label: 'Group', parent: 'three' },
  { value: 'user', label: 'User', parent: 'table' },
];

const Definitions = ({ response, setSelectedDefinition, setSelectedTask, setSelectedGroups }: Props) => {
  const definitions = response.reference?.definitions;

  return (
    <Hierarchy
      title="definitions"
      hasSearch
      searchTypeValues={searchTypeValues}
      parentsOne={definitions}
      parentOneName="wfName"
      parentOneId="idDefinition"
      parentOneSelection={(value: any) => {
        setSelectedTask && setSelectedTask();
        setSelectedGroups && setSelectedGroups([]);
        setSelectedDefinition && setSelectedDefinition(value);
      }}
      parentOneChild="tasks"
      parentTwoName="taskName"
      parentTwoId="idTask"
      parentTwoSelection={(isActive?: boolean, value?: any) => {
        setSelectedTask && setSelectedTask(isActive, value);
        setSelectedGroups && setSelectedGroups([]);
      }}
      parentTwoChild="groups"
      parentThreeName="groupName"
      parentThreeId="idGroup"
      parentThreeSelection={(value?: any) => {
        setSelectedGroups && setSelectedGroups(value);
      }}
      parentThreeChild="users"
      parentThreeMulti={true}
      idRowTable="idUser"
      columns={columns}
      tableValueName="username"
      tableValueNameTwo="name"
    />
  );
};

export default Definitions;
